const routes = {
    login: { path: "/login" },
    home: { path: "/" }
};

export default routes;